export default __webpack_public_path__ + "static/media/BoardGameTechnicalWriting.4d296f99.png";